module.exports = __webpack_public_path__ + "static/media/avc_head_c.88a24ab2.svg";